<template>
  <section>
    <div class="title">
      <span>价格配置</span>
    </div>
    <CommPriceConfKj ref="commPriceConfRef" :config="getPriceName(platform)" :commonPrice="kj_commonPrice" :platform="platform" />
  </section>
</template>
<script>
import '@/assets/css/prod.scss';
import CommPriceConfKj from './CommPriceConfKj.vue'
import { getPriceName } from '@/dictionary/price';

export default {
  props: {
    platform: String,
    priceList: {
      type: Array,
      default: () => [],
    },
    shopPriceConf:{
      type:Array,
      default: () => []
    },
    // 跨境专属 通用/店铺价格配置
    kj_commonPrice:{
      type:Object,
      default: () => {}
    },
  },
  components: {
      CommPriceConfKj,
  },
  computed:{
    // isKjShopConf(){
    //   return ['pddtemu','pddtemu_btg'].includes(this.platform)
    // }
  },
  data() {
    return {
      activeName:'commConf',
      getPriceName
    };
  },
  methods: {
    getData() {
      let commConf = this.$refs.commPriceConfRef.getData();
      return commConf
    },
  },
};
</script>

<style lang="scss">

</style>